import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import {
  distinctUntilChanged,
  filter,
  first,
  firstValueFrom,
  map,
  of,
  race,
  switchMap,
} from 'rxjs';
import { communityActions, communitySelectors } from '@redux/community.effects';
import { equals } from '@functions/helper.functions';
import { authenticationActions, selectAuthentication } from '@redux/authentication.redux';
import { isEqual } from 'lodash-es';
export const communityGuard: CanActivateFn = (route) => {
  const store = inject(Store);
  const router = inject(Router);
  const slug = route.params['community'] ?? localStorage.getItem('community');
  const token = localStorage.getItem('token');
  if (!slug) {
    router.navigate(['/404']).then();
    return false;
  }
  //
  if (token) {
    store.dispatch(authenticationActions.loadSession());
    return store.select(selectAuthentication.selectUserAndCommunity).pipe(
      distinctUntilChanged((prev, curr) => isEqual(prev, curr)),
      filter(({ user, community }) => !!user && !!community),
      switchMap(({ user, community }) => {


        if (user && community) {
          if (equals(community.code, slug)) {
            router.navigate(['/']).then();
            return of(false);
          }
        }

        store.dispatch(authenticationActions.logout(slug));
        return of(true);
      }),
    );
  }
  store.dispatch(communityActions.read({ path: `communities/code`, params: { code: slug } }));
  return firstValueFrom(
    race(
      store.select(communitySelectors.selectModel).pipe(
        first((community) => !!community),
        map((community) => {
          if (community && equals(community.code, slug)) {
            return true;
          } else {
            router.navigate(['/404']).then();
            return false;
          }
        }),
      ),
      store.select(communitySelectors.selectError).pipe(
        first((error) => !!error),
        map(() => {
          router.navigate(['/404']).then();
          return false;
        }),
      ),
    ),
  );
};
